module.exports = __webpack_public_path__ + "static/media/similar-marker.dbeafea7.svg";